export default defineNuxtRouteMiddleware((to) => {
	const authStore = useAuthStore()
	const appConfig = useAppConfig()
	const toastStore = useToastStore()

	const isAuthenticated = authStore.isAuthenticated
	const unguardedRoutes = ["/forgotPassword", "/resetPassword", "/resetPassword/", "/login", "/maintenance"]

	if (appConfig.showMaintenancePage) {
		authStore.$reset()
		if (to.path !== "/maintenance") {
			return navigateTo("/maintenance")
		}
	}

	// Allow access to unguarded routes
	if (unguardedRoutes.includes(to.path)) {
		return
	}

	// Redirect to login if not authenticated or token is expired
	const wasTokenExpired = authStore.isTokenExpired()
	if (!isAuthenticated || wasTokenExpired) {
		if (wasTokenExpired) {
			// @ts-ignore
			toastStore.setError("Your session has expired")
			// Temporary fix to prevent errors loading message strings from the message bundle.
			// Otherwise, I need to overall the authentication logic to allow for custom session expiry messages.
			// toastStore.setError($messages.$t("loggedOutInactive"))
		}

		return navigateTo("/login")
	}

	// If authenticated and token is not expired, allow access to all pages
})
